(() => {
  'use strict';
  const template = document.getElementById('FultonsFinanceRow');
  const dialog = document.getElementById('FultonsFinancePanel');
  const dataElement = document.getElementById('FultonsFinanceVariantData');
  if (!template || !dialog || !dataElement) return;
  let data;
  try { data = JSON.parse(dataElement.textContent); } catch { return; }
  const money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  const main = document.getElementById('MainContent');
  if (!main) return;
  let root;
  let row;
  let trigger;
  let queued = false;
  const visible = el => Boolean(el && el.getClientRects().length && !el.closest('[hidden]'));
  const selectedPrice = () => {
    const form = [...root.querySelectorAll('form[action*="/cart/add"]')].find(visible);
    const input = form?.querySelector('[name="id"]');
    const variant = !input?.disabled && data.variants.find(v => v.id === input?.value);
    const pricedVariant = variant && Number.isInteger(variant.price) && variant.price > 0;
    if (pricedVariant && !form.matches('.fh-bed-purchase')) return { price: variant.price, exact: true };
    const node = [...root.querySelectorAll('.fultons-selected-price')].find(visible) || [...root.querySelectorAll('[data-fixed-piece-price="true"],.fultons-retail-price,.catalogue-proof__price,.fultons-online-product__price')].find(visible);
    const match = node?.textContent.match(/£\s*([\d,]+(?:\.\d{2})?)/);
    const displayedPrice = match ? Math.round(Number(match[1].replaceAll(',', '')) * 100) : 0;
    return { price: displayedPrice, exact: Boolean(pricedVariant && displayedPrice === variant.price) };
  };
  const update = () => {
    queued = false;
    root = [...main.querySelectorAll('.catalogue-proof,.pdp-refined,.fultons-online-product')].find(visible);
    if (!root || root.classList.contains('fultons-clearance-product')) { if (row) row.hidden = true; return; }
    const purchase = [...root.querySelectorAll('form[action*="/cart/add"] [class$="purchase__controls"],.fultons-online-product__controls,form.fh-bed-purchase .fh-bed-buy')].find(visible);
    const enquiry = [...root.querySelectorAll('a.catalogue-proof__enquire,a.pdp-refined__enquire,[data-stressless-enquire],[data-natuzzi-enquiry],[data-manual-enquiry]')].find(visible);
    const anchor = purchase || enquiry;
    if (!anchor) { if (row) row.hidden = true; return; }
    const amount = selectedPrice();
    if (!row) {
      row = template.content.firstElementChild.cloneNode(true);
      trigger = row.querySelector('button');
    }
    root.querySelectorAll('.fultons-finance-note').forEach(existing => { if (existing !== row) existing.remove(); });
    if (anchor.nextElementSibling !== row) anchor.after(row);
    row.hidden = Boolean(amount.price && amount.price < 100000);
    const illustration = dialog.querySelector('[data-finance-illustration]');
    illustration.hidden = !amount.exact || amount.price < 100000 || amount.price >= 500000;
    if (!illustration.hidden) {
      const deposit = Math.round(amount.price * .2), credit = amount.price - deposit;
      for (const [key, cents] of Object.entries({cash:amount.price,deposit,credit,monthly:Math.round(credit / 12)})) {
        const node = dialog.querySelector('[data-finance-' + key + ']');
        const value = money.format(cents / 100).replace(/\.00$/, '');
        if (node.textContent !== value) node.textContent = value;
      }
    }
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
  document.addEventListener('click', event => {
    const opener = event.target.closest('.fultons-novuna-note__button');
    if (!opener) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    update();
    trigger = opener;
    dialog.showModal();
    dialog.querySelector('h2').focus({preventScroll:true});
  }, true);
  dialog.querySelector('.fultons-novuna-panel__close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => trigger?.focus({preventScroll:true}));
  main.addEventListener('change', schedule);
  new MutationObserver(records => {
    if (records.some(record => !record.target.closest?.('[data-fultons-finance-row]'))) schedule();
  }).observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden','data-exact-variant-id','data-selected-price','data-online-checkout-enabled'] });
  update();
})();




